<template>
  <!-- <svg
    viewBox="6 0 180 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin: 0.5rem 1rem"
  >
    <path
      d="M96 1H11C8.23858 1 6 3.23858 6 6V115C6 117.761 8.23858 120 11 120H96V1Z"
      fill="#E3F5FC"
    />
    <path
      opacity="0.675"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.5564 94.5005C47.509 96.4531 50.6749 96.4531 52.6275 94.5005L74.5924 72.5355C76.545 70.5829 79.7109 70.5829 81.6635 72.5355L96 86.8721V120.053H71.1089H27.075H12.0711C7.61655 120.053 5.3857 114.667 8.53553 111.517L32.0189 88.034C33.9715 86.0814 37.1374 86.0814 39.09 88.034L45.5564 94.5005Z"
      fill="#00ADE8"
    />
    <path
      opacity="0.675"
      d="M43.8337 46.8266C49.346 46.8266 53.8146 42.358 53.8146 36.8457C53.8146 31.3334 49.346 26.8649 43.8337 26.8649C38.3215 26.8649 33.8529 31.3334 33.8529 36.8457C33.8529 42.358 38.3215 46.8266 43.8337 46.8266Z"
      fill="#00ADE8"
    />
    <rect x="107" y="65" width="63" height="16" rx="1" stroke="#00ADE8" stroke-width="2" />
    <rect x="107" y="40" width="63" height="16" rx="1" stroke="#00ADE8" stroke-width="2" />
    <rect x="106" y="14" width="65" height="5" rx="2.5" fill="#E3F5FC" />
    <rect x="124" y="24" width="29" height="5" rx="2.5" fill="#E3F5FC" />
    <rect x="106" y="89" width="65" height="18" rx="2" fill="#00ADE8" />
    <rect x="7" y="1" width="178" height="118" rx="4" stroke="#00ADE8" stroke-width="2" />
  </svg> -->
  <svg style="margin: 0.5rem 1rem" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1302_96996)">
      <path
        d="M2 5.95928C2 3.21906 4.40703 1 7.37582 1H88V119H7.37582C4.40703 119 2 116.781 2 114.041V5.95928Z"
        fill="#CCDCF3"
      />
      <path
        d="M21.7559 67.0702C24.9827 70.5053 28.0593 73.7798 31.2273 77.1526C41.734 66.5162 52.0023 56.1224 62.46 45.5385C66.6894 49.816 70.6021 53.7919 74.5408 57.7482C78.6397 61.8683 82.8005 65.9328 86.8373 70.112C87.5003 70.8003 88.0032 71.9639 88.013 72.9144C88.1012 81.476 88.0653 110.245 88.0653 118.964H2.00651C2.00651 115.129 1.97711 91.1684 2.0457 87.4219C2.05223 86.9728 2.516 86.4681 2.87852 86.101C9.03491 79.8765 15.2076 73.6651 21.7592 67.0735L21.7559 67.0702Z"
        fill="#0059D5"
      />
      <path
        d="M25.5771 19.6145C32.0732 19.6735 37.4098 25.1244 37.3053 31.5817C37.1975 38.0061 31.6519 43.4144 25.2767 43.3161C18.7153 43.2112 13.5289 37.7603 13.6138 31.0605C13.6955 24.6918 19.0648 19.5555 25.5804 19.6178L25.5771 19.6145Z"
        fill="#0059D5"
      />
    </g>
    <rect x="101" y="65" width="63" height="16" rx="1" stroke="#0059D5" stroke-width="2" />
    <rect x="101" y="40" width="63" height="16" rx="1" stroke="#0059D5" stroke-width="2" />
    <rect x="100" y="14" width="65" height="5" rx="2.5" fill="#CCDCF3" />
    <rect x="118" y="24" width="29" height="5" rx="2.5" fill="#CCDCF3" />
    <rect x="100" y="89" width="65" height="18" rx="2" fill="#0059D5" />
    <rect x="1" y="1" width="178" height="118" rx="4" stroke="#0059D5" stroke-width="2" />
    <defs>
      <clipPath id="clip0_1302_96996">
        <rect width="86" height="118" fill="white" transform="translate(2 1)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>
